import api from "@/axios";
import type { AxiosResponse } from "axios";
import type {Product, YarnUsed, StitchLength, KnittingSetOut, ArchivedProductSpecification} from '@/types/product-types'
import type {LinkedProduct} from "@/types/customer-types";

export const addProduct = async (data: Product): Promise<AxiosResponse> => {
    const response = await api.post("/products", data);
    return response.data;
}

export const getProductList = async (): Promise<Product[]> => {
    const response = await api.get("/products");
    return response.data;
}

export const getProductById = async (id: string): Promise<Product> => {
    const response = await api.get(`/products/${id}`);
    return response.data;
}

export const editProduct = async (data: Product, id: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${id}`, data);
    return response.data;
}

export const addYarnUsedToProduct = async (
    id: string,
    data: YarnUsed
): Promise<AxiosResponse> => {
    const response = await api.post(`/products/${id}/yarn-used`, data)
    return response.data
}

export const editYarnUsedForProduct = async (
    productId: string,
    data: YarnUsed,
    yarnUsedId?: string
): Promise<AxiosResponse> => {
    const response = await api.patch(`products/${productId}/yarn-used/${yarnUsedId}`, data)
    return response.data
}

export const deleteYarnUsedFromProduct = async (
    productId: string,
    yarnUsedId: string
): Promise<AxiosResponse> => {
    const response = await api.delete(`/products/${productId}/yarn-used/${yarnUsedId}`)
    return response.data
}

export const addStitchLength = async (productId: string, data: StitchLength): Promise<AxiosResponse> => {
    const response = await api.post(`/products/${productId}/stitch-length`, data);
    return response.data;
}

export const editStitchLengthForProduct = async (
    productId: string,
    data: StitchLength,
    stitchLengthId?: string
): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${productId}/stitch-lengths/${stitchLengthId}`, data)
    return response.data
}

export const deleteStitchLengthFromProduct = async (
    productId: string,
    stitchLengthId: string
): Promise<AxiosResponse> => {
    const response = await api.delete(`/products/${productId}/stitch-lengths/${stitchLengthId}`)
    return response.data
}

export const getStitchLengths = async (productId: string, stitchLengthId: string): Promise<StitchLength> => {
    const response = await api.get(`/products/${productId}/stitch-lengths${stitchLengthId}`);
    return response.data;
}

export const addYarnSetOutToProduct = async (productId: string, data: any): Promise<AxiosResponse> => {
    const response = await api.post(`/products/${productId}/yarn-set-out`, data);
    return response.data;
}

export const editYarnSetOutForProduct = async (productId: string, data: any, yarnSetOutId?: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${productId}/yarn-set-out/${yarnSetOutId}`, data);
    return response.data;
}

export const addKnittingSetOutToProduct = async (productId: string, data: KnittingSetOut): Promise<AxiosResponse> => {
    const response = await api.post(`/products/${productId}/knitting-set-out`, data);
    return response.data;
}

export const editKnittingSetOutForProduct = async (productId: string, data: KnittingSetOut, knittingSetOutId?: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${productId}/knitting-set-out/${knittingSetOutId}`, data);
    return response.data;
}

export const deleteKnittingSetOutFromProduct = async (productId: string, knittingSetOutId: string): Promise<AxiosResponse> => {
    const response = await api.delete(`/products/${productId}/knitting-set-out/${knittingSetOutId}`);
    return response.data;
}

export const archiveProductSpecification = async (productId: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${productId}/archive`)
    return response.data
}

export const unarchiveProductSpecification = async (productId: string): Promise<AxiosResponse> => {
    const response = await api.patch(`/products/${productId}/unarchive`)
    return response.data
}

export const getArchivedProductSpecifications = async (): Promise<ArchivedProductSpecification[]> => {
    const response = await api.get('/products/archived')
    return response.data
}